@import '../../styles/modals.css';
@import '../../styles/buttons.css';

:host {
  display: block;
}

.confirmation-message {
  font-size: 14px;
  padding: 16px;
}

tambr-checkout-order-price {
  border-top: 1px solid #d5d9de;
  border-bottom: 1px solid #d5d9de;
}